import React, { Component } from "react";

// Assets
import Mail from "../../Assets/mail.svg";
import Phone from "../../Assets/phone.svg";
import Logo from "../../Assets/Logo.svg";
import insta from "../../Assets/insta.svg";
import linkedIn from "../../Assets/linkedin.svg";
import fbook from "../../Assets/facebook.svg";
import twiteer from "../../Assets/twitter.svg";
import ytube from "../../Assets/youtube.svg";

// Footer Component
export default class Footer extends Component {
  contactBlock() {
    return (
      <div className="Home_ContactBlock">
        <div className="Home_CBlock1">
          <div className="Home_ContactMainTitle">Contact With Us</div>
          <div className="Home_ContactDesc">
            Connect with us by sending your details. We Connect with you as soon
            as possible !
          </div>
          <div className="Home_ContactDetails">
            <div className="Home_CDetail">
              <img src={Phone} alt="phone icon" />
              +91 9890945819 / 9175014178
            </div>
            <div className="Home_CDetail">
              <img src={Mail} alt="mail icon" />
              mellituscareinfo@gmail.com
            </div>
          </div>
        </div>
        <div className="Home_CBlock2">
          <div className="Home_ContactCard">
            <div className="Home_Circle"></div>
            <div className="Home_CCTitle">Enter Details</div>
            <div className="Home_CCInputBlock">
              <form>
                <input
                  className="Home_CCInputFields"
                  type="text"
                  placeholder="Name"
                />
                <input
                  className="Home_CCInputFields"
                  type="email"
                  placeholder="Email"
                  onKeyPress={(event) =>
                    event.key !== " " ? true : event.preventDefault()
                  }
                />
                <input
                  className="Home_CCInputFields"
                  type="text"
                  placeholder="Phone Number"
                  maxLength={10}
                  onKeyPress={(event) =>
                    event.key !== " " && event.key >= 0 && event.key <= 9
                      ? true
                      : event.preventDefault()
                  }
                />
                <input
                  className="Home_CCInputFields"
                  type="text"
                  placeholder="How Can We Help?"
                />
                <button
                  className="Home_CCInputButton"
                  type="submit"
                  onClick={(e) => e.preventDefault()}
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }

  footerBlock() {
    return (
      <div className="Home_FooterBlock">
        <div className="Home_FLogoBlock">
          <img src={Logo} className="Home_FMCLogo" />
          <div className="Home_FMCName">Mellitus Care</div>
        </div>
        <div className="Home_DescBlock">
          <p className="Home_FooterDesc">
            Mellitus Care is a web-based application useful for a user having
            diabetes. We helps our user to have a track over their blood glucose
            and also suggest them for a diet.
          </p>
        </div>
        <div className="Home_FooterLine"></div>
        <div className="Home_FooterInfo">
          <div className="Home_FooterRight">
            ©MELLITUSCARE PTY LTD 2022. All rights reserved.
          </div>
          <div className="Home_FContact">
            <div className="Home_FCTitle">Contact</div>
            <div className="Home_FCNumber">+919890945819</div>
          </div>
          <div className="Home_FSocialBlock">
            <div className="Home_FFTitle">Follow Us</div>
            <div className="Home_FFBlock">
              <div
                className="youtube social"
                style={{ backgroundImage: `url(${ytube})` }}
              ></div>
              <div
                className="tweet social"
                style={{ backgroundImage: `url(${twiteer})` }}
              ></div>
              <div
                className="insta social"
                style={{ backgroundImage: `url(${insta})` }}
              ></div>
              <div
                className="facebook social"
                style={{ backgroundImage: `url(${fbook})` }}
              ></div>
              <div
                className="linkedIn social"
                style={{ backgroundImage: `url(${linkedIn})` }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="Home_ContactFooterBlock">
        {this.contactBlock()}
        {this.footerBlock()}
      </div>
    );
  }
}
